module.exports = __webpack_public_path__ + "static/media/Corasol.2e40bc69.png";